import { render, staticRenderFns } from "./MigratingWorkspaceLoaderModal.vue?vue&type=template&id=2d801e4a&scoped=true"
import script from "./MigratingWorkspaceLoaderModal.vue?vue&type=script&lang=js"
export * from "./MigratingWorkspaceLoaderModal.vue?vue&type=script&lang=js"
import style0 from "./MigratingWorkspaceLoaderModal.vue?vue&type=style&index=0&id=2d801e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d801e4a",
  null
  
)

export default component.exports